module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.maintenance_mode && _vm.user.access < 6) ? _c('maintenance') : _c('div', {
    staticClass: "admin-app"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('page-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])], 1), _vm._v(" "), _c('page-footer'), _vm._v(" "), _c('session-timeout-modal', {
    attrs: {
      "seconds-to-session-end": _vm.secondsToSessionEnd
    },
    on: {
      "logout": _vm.logout,
      "refresh": _vm.refreshAction
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c33eb3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin.vue
// module id = 1653
// module chunks = 1